export default __webpack_public_path__ + "f7aea6dca356de1026560b722c4742cc.png";